import axios from "axios";
import "./request_interceptor";


//const end_point1 = "http://192.168.30.225:88/api/stock_service/";
//const end_point1 = "https://preprodb.portailachats.ma/api/stock_service/";

const end_point1 = process.env.REACT_APP_API_URL + "/api/roles_habilitations";

////////////////////////////////////////////////////
////
////////////////////////////////////////////////////

export const get_all_roles_habilitations = async () => {
  return await axios.get(end_point1);
};

export const get_active_habilitations = async () => {
  return await axios.get(end_point1+"/active");
};

export const get_habilitations_by_role = async (role_code) => {
  return await axios.get(end_point1 + "/" + role_code);
};

export const create_role_habilitation = async (data) => {
  return await axios.post(end_point1,data);
};

export const update_role_habilitation = async (role_code,data) => {
  return await axios.put(end_point1 + "/" + role_code,data);
};

export const toggle_role_habilitation = async (role_code) => {
  return await axios.patch(end_point1 + "/" + role_code + "/toggle");
};